import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { exitSelectingText } from './getClearSelectionMenuItem.locstring.json';
import loc from 'owa-localize';
import { lazyClearSelectedAssets } from 'owa-calendar-board';

export function getClearSelectionMenuItem() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(exitSelectingText),
        [FilterableMenuItemArgs.icon]: ControlIcons.ClearSelection,
        [FilterableMenuItemArgs.onClick]: lazyClearSelectedAssets.tryImportForRender(),
    });
}
